import axios from "axios";
import apiurl from "../../server/api";
import { AuthInstance } from "../../helper/AxiosInstance";

const auth = () => ({ headers: { Authorization: `JWT ${localStorage.getItem("token") || ""}` } });

export const getSellerOnboarding = () => axios.get(`${apiurl}/api/vendor/onboarding/me/`, auth());
export const getOnboardingAccess = () => AuthInstance.get("/api/vendor/onboarding/access/");
export const updateSellerProfile = (body) => axios.patch(`${apiurl}/api/vendor/onboarding/profile/`, body, auth());
export const getSellerAddresses = () => axios.get(`${apiurl}/api/vendor/onboarding/addresses/`, auth());
export const addSellerAddress = (body) => axios.post(`${apiurl}/api/vendor/onboarding/addresses/`, body, auth());
export const createSellerVendor = (body) => axios.post(`${apiurl}/api/vendor/onboarding/admin/vendors/create/`, body, auth());
export const activateSeller = (body) => axios.post(`${apiurl}/api/vendor/activate/`, body);
export const submitSellerApplication = (id, revision) => axios.post(
  `${apiurl}/api/vendor/onboarding/applications/${id}/submit/`, { revision }, auth()
);
export const uploadSellerDocument = (slotId, file, onUploadProgress) => {
  const body = new FormData();
  body.append("file", file);
  return axios.post(`${apiurl}/api/vendor/onboarding/document-slots/${slotId}/upload/`, body, {
    ...auth(), onUploadProgress,
  });
};

export const getVendorRoles = (vendorId) => axios.get(
  `${apiurl}/api/vendor/onboarding/admin/vendors/${vendorId}/roles/`, auth()
);
export const assignVendorRole = (vendorId, userId, groupId) => axios.post(
  `${apiurl}/api/vendor/onboarding/admin/vendors/${vendorId}/roles/`,
  { user_id: userId, group_id: groupId }, auth()
);
export const revokeVendorRole = (vendorId, assignmentId) => axios.post(
  `${apiurl}/api/vendor/onboarding/admin/vendors/${vendorId}/roles/${assignmentId}/revoke/`, {}, auth()
);
